import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import { IActivityContext } from "@wingspanhq/users";
import classNames from "classnames";
import React from "react";
import IABenefitsLogo from "../../assets/images/IABenefits.png";
import UnderwriterServicesAssociationLogo from "../../assets/images/UnderwriterServicesAssociationLogo.png";
import wingspanLogo from "../../assets/images/ws-logo.svg";
import { useUserId } from "../../query/hooks/helpers";
import { useActivities } from "../../query/users/queries";
import {
  isIAPathMember,
  isUnderWriterMember
} from "../../utils/growthAttribution";
import styles from "./ResponsiveWingspanLogo.module.scss";

type Props = WSElementProps & {
  inline?: boolean;
};

export const ResponsiveWingspanLogo: React.FC<Props> = ({
  className,
  inline,
  ...elementProps
}) => {
  const userId = useUserId();
  const activityQuery = useActivities(userId);
  let logo = {
    src: wingspanLogo,
    alt: "Wingspan logo"
  };
  const isMemberFromUSA = isUnderWriterMember(
    activityQuery.data?.context as IActivityContext
  );
  const isMemberFromIABenefits = isIAPathMember(
    activityQuery.data?.context as IActivityContext
  );
  if (isMemberFromUSA) {
    logo = {
      src: UnderwriterServicesAssociationLogo,
      alt: "Logo"
    };
  } else if (isMemberFromIABenefits) {
    logo = {
      src: IABenefitsLogo,
      alt: "Logo"
    };
  }
  return (
    <WSElement
      as="img"
      {...logo}
      className={classNames(styles.logo, className, {
        [styles.partner]: isMemberFromUSA || isMemberFromIABenefits,
        [styles.inline]: inline
      })}
      {...elementProps}
    />
  );
};
